module.exports = __webpack_public_path__ + "static/media/399.8d3993b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/399.svg
// module id = 173
// module chunks = 0